// One muted palette for the home screen and its report modals.
//
// The home page used the platform's full-saturation status colours on 26px
// numbers, so every panel competed for attention. Here colour only marks
// meaning — a 6px dot, a 6px bar, a chart series — so the values themselves can
// stay neutral ink. The hues are the same semantics as the status pills
// (red = flags, amber = waiting, green = done, purple = stalled), desaturated
// about 25% so a screen full of them reads calm.
export const HOME_INK = "#1F2430";
export const HOME_INK_SOFT = "#6B7280";
export const HOME_LINE = "#EBE7EA";
export const HOME_TRACK = "#F2F0F2";

export const HOME_BRAND = "#AA1A5F";

export const HOME_COLORS = {
  brand: HOME_BRAND,
  alert: "#C2482F", // red flags, overdue
  warn: "#C08A2E", // waiting / in progress
  ok: "#3F8F6B", // completed, approved, on time
  stalled: "#7A6FA8", // gone quiet
  info: "#4A7DB5", // planned / target
  neutral: "#8A8F9C", // archived, no data
};

// Ordered series for charts that need more than one colour. Brand first, then
// the semantic hues — no rainbow, and adjacent entries stay distinguishable in
// greyscale (print/PDF export) because their lightness steps.
export const HOME_SERIES = [
  HOME_COLORS.brand,
  HOME_COLORS.info,
  HOME_COLORS.warn,
  HOME_COLORS.ok,
  HOME_COLORS.stalled,
  HOME_COLORS.alert,
  HOME_COLORS.neutral,
];

// A status enum's `fill` may be a CSS var() token ("var(--x, #FC9403)"), which
// canvas cannot resolve — pull the raw hex out.
export const hexOf = (fill) => {
  const match = /#([0-9a-fA-F]{3,8})/.exec(fill || "");
  return match ? match[0] : fill || HOME_COLORS.neutral;
};

// Mute an arbitrary hex towards the palette's calm level: blends it 30% into
// the page's ink-grey. Used where a colour comes from an enum we don't own.
export const muted = (hex, amount = 0.3) => {
  const raw = hexOf(hex).replace("#", "");
  if (raw.length !== 6) return hex;
  const mix = (channel, target) =>
    Math.round(channel + (target - channel) * amount);
  const r = mix(parseInt(raw.slice(0, 2), 16), 138);
  const g = mix(parseInt(raw.slice(2, 4), 16), 143);
  const b = mix(parseInt(raw.slice(4, 6), 16), 156);
  return `#${[r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("")}`;
};

// Ordinal severity scale for the Visit Data Summary's accessibility and
// visit-status charts: four steps that stay distinguishable both in colour and
// in greyscale (they step in lightness), and sit at the same muted level as
// HOME_COLORS.
export const HOME_SCALE = {
  critical: HOME_COLORS.alert,
  poor: "#C77A3E",
  fair: HOME_COLORS.warn,
  good: HOME_COLORS.ok,
};

export default HOME_COLORS;
